import { filterSportsContent, extractYear, extractWikiLinks } from './onThisDayUtils';

export const fetchWikipediaAllEndpoints = async (month, day) => {
  const endpoints = [
    `https://api.wikimedia.org/feed/v1/wikipedia/en/onthisday/all/${month}/${day}`,
    `https://api.wikimedia.org/feed/v1/wikipedia/en/onthisday/events/${month}/${day}`,
    `https://api.wikimedia.org/feed/v1/wikipedia/en/onthisday/births/${month}/${day}`,
    `https://api.wikimedia.org/feed/v1/wikipedia/en/onthisday/deaths/${month}/${day}`,
    `https://api.wikimedia.org/feed/v1/wikipedia/en/onthisday/selected/${month}/${day}`
  ];

  const headers = {
    'Api-User-Agent': 'SportsHistoryApp/3.0 (Educational Purpose)'
  };

  try {
    const responses = await Promise.all(
      endpoints.map(url =>
        fetch(url, { headers })
          .then(res => res.ok ? res.json() : null)
          .catch(() => null)
      )
    );

    const combinedData = { events: [], births: [], deaths: [] };

    responses.forEach(data => {
      if (data) {
        if (data.events) combinedData.events.push(...data.events);
        if (data.selected) combinedData.events.push(...data.selected);
        if (data.births) combinedData.births.push(...data.births);
        if (data.deaths) combinedData.deaths.push(...data.deaths);
      }
    });

    return filterSportsContent(combinedData);
  } catch (error) {
    console.error('Wikipedia API error:', error);
    return null;
  }
};

export const fetchWikipediaEnhanced = async (month, day) => {
  try {
    const url = `https://en.wikipedia.org/api/rest_v1/feed/onthisday/all/${month}/${day}`;
    const response = await fetch(url);

    if (!response.ok) return null;

    const data = await response.json();

    const formattedData = {
      events: (data.events || []).map(item => ({
        text: item.text,
        year: item.year || extractYear(item.text),
        pages: item.pages || []
      })),
      births: (data.births || []).map(item => ({
        text: item.text,
        year: item.year || extractYear(item.text),
        pages: item.pages || []
      })),
      deaths: (data.deaths || []).map(item => ({
        text: item.text,
        year: item.year || extractYear(item.text),
        pages: item.pages || []
      }))
    };

    return filterSportsContent(formattedData);
  } catch (error) {
    console.error('Wikipedia enhanced API error:', error);
    return null;
  }
};

export const fetchZenQuotesData = async (month, day) => {
  try {
    const response = await fetch(`https://today.zenquotes.io/api/${parseInt(month)}/${parseInt(day)}`);

    if (!response.ok) return null;

    const data = await response.json();

    if (!data.data) return null;

    const formattedData = {
      events: (data.data.Events || []).map(item => ({
        text: item.text,
        year: extractYear(item.text),
        pages: extractWikiLinks(item.html)
      })),
      births: (data.data.Births || []).map(item => ({
        text: item.text,
        year: extractYear(item.text),
        pages: extractWikiLinks(item.html)
      })),
      deaths: (data.data.Deaths || []).map(item => ({
        text: item.text,
        year: extractYear(item.text),
        pages: extractWikiLinks(item.html)
      }))
    };

    return filterSportsContent(formattedData);
  } catch (error) {
    console.error('ZenQuotes API error:', error);
    return null;
  }
};

export const fetchMuffinLabsData = async (month, day) => {
  try {
    const response = await fetch(`https://history.muffinlabs.com/date/${month}/${day}`);

    if (!response.ok) return null;

    const data = await response.json();

    if (!data.data) return null;

    const formattedData = {
      events: (data.data.Events || []).map(item => ({
        text: item.text || item.year + ' - ' + item.html,
        year: parseInt(item.year) || extractYear(item.text),
        pages: item.links || []
      })),
      births: (data.data.Births || []).map(item => ({
        text: item.text || item.year + ' - ' + item.html,
        year: parseInt(item.year) || extractYear(item.text),
        pages: item.links || []
      })),
      deaths: (data.data.Deaths || []).map(item => ({
        text: item.text || item.year + ' - ' + item.html,
        year: parseInt(item.year) || extractYear(item.text),
        pages: item.links || []
      }))
    };

    return filterSportsContent(formattedData);
  } catch (error) {
    console.error('MuffinLabs API error:', error);
    return null;
  }
};

export const fetchDayInHistoryData = async (month, day) => {
  try {
    const response = await fetch(`https://dayinhistory.dev/api/events/${month}/${day}`);

    if (!response.ok) return null;

    const data = await response.json();

    const formattedData = {
      events: (data.events || []).map(item => ({
        text: item.description || item.text || item.event,
        year: item.year || extractYear(item.description || item.text),
        pages: []
      })),
      births: (data.births || []).map(item => ({
        text: item.description || item.text || item.name,
        year: item.year || extractYear(item.description || item.text),
        pages: []
      })),
      deaths: (data.deaths || []).map(item => ({
        text: item.description || item.text || item.name,
        year: item.year || extractYear(item.description || item.text),
        pages: []
      }))
    };

    return filterSportsContent(formattedData);
  } catch (error) {
    console.error('DayInHistory API error:', error);
    return null;
  }
};
